import {BaseEntityUnDeletable} from '../../../common/entities';

export class Reference extends BaseEntityUnDeletable {
    description: string;
}
